import { render, staticRenderFns } from "./LocationLabStatisticsDialog.vue?vue&type=template&id=872f15fe&scoped=true&"
import script from "./LocationLabStatisticsDialog.vue?vue&type=script&lang=js&"
export * from "./LocationLabStatisticsDialog.vue?vue&type=script&lang=js&"
import style0 from "./LocationLabStatisticsDialog.vue?vue&type=style&index=0&id=872f15fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872f15fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRow,VSpacer})
